function min2DArray(arr) {
    var outer_min = Number.MAX_VALUE;

    arr.forEach(function(lst) {

        let inner_min = Number.MAX_VALUE;

        lst.forEach(function (item){
            if (inner_min > item) {
                inner_min = item;
            }
        })

        if (outer_min > inner_min){
            outer_min = inner_min
        }

    });
    return outer_min;
}


function max2DArray(arr) {
    var outer_max = -Number.MAX_VALUE;

    arr.forEach(function(lst) {
        let inner_max = -Number.MAX_VALUE;

        lst.forEach(function (item){
            if (inner_max  < item) {
                inner_max  = item;
            }

        })

        if (outer_max < inner_max){
            outer_max = inner_max
        }


    });
    return outer_max;
}


export const ExtremeFinder = (tracks) => {
    // console.log(tracks)
    var start_values = tracks.map(track => track["genes"].map(gene => gene["start"] + track["offset"]))
    var end_values = tracks.map(track => track["genes"].map(gene => gene["end"] + track["offset"]))


    // use Math.min and Math.max are easy to crash!!!!!!
    // const min = Math.min(...[].concat(...start_values))
    // const max = Math.max(...[].concat(...end_values))

    const min = min2DArray(start_values)
    const max = max2DArray(end_values)

    return [min, max];
}